import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { reload } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        await reload();
        window.history.replaceState(null, "", location.pathname);
        toast.success(`Signed in as ${data.user.email}`);
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, reload]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0f17] text-slate-400 text-sm font-mono" data-testid="auth-callback">
      Completing Google sign-in…
    </div>
  );
}
